import script from "./OTabelaAtividadesProjeto.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaAtividadesProjeto.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaAtividadesProjeto.vue?vue&type=style&index=0&id=33fdfb12&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33fdfb12"]])

export default __exports__